import { useContext } from "react"
import BreadCrumbsContext from "../contexts/bread-crumbs-provider"

export function useBreadCrumbsContext() {
  return useContext(BreadCrumbsContext)
}
